exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-contentful-page-slug-js": () => import("./../../../src/pages/{ContentfulPage.slug}.js" /* webpackChunkName: "component---src-pages-contentful-page-slug-js" */),
  "component---src-pages-contentful-product-page-product-slug-js": () => import("./../../../src/pages/{ContentfulProductPage.product__slug}.js" /* webpackChunkName: "component---src-pages-contentful-product-page-product-slug-js" */)
}

